import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectToken } from "redux-store/features/authSlice";
import {
  selectCategoryManagementData,
  setCategories,
} from "redux-store/features/categoryManagement";
import CategoryService from "services/CategoryService";
import { setUpCategoryIfPrefilledExists } from "./helpers";

export const useMultiSelect = (props = {}) => {
  const { preSelected, setValue, noFilter = false, value = null } = props;

  const { categories } = useSelector(selectCategoryManagementData);
  const token = useSelector(selectToken);
  const dispatch = useDispatch();

  const [selectedCategoryTree, setSelectedCategoryTree] = useState([]);
  const [categoryInput, setCategoyInput] = useState({});
  const [dropdownMatrix, setDropdownMatrix] = useState([]);
  const userInteraction = useRef(false);

  const getCategories = async () => {
    try {
      const res = await CategoryService.getAvailableCategories(token, dispatch);

      dispatch(setCategories(res.data.data));
    } catch (e) {}
  };

  const fetchCategoryTree = async (category) => {
    try {
      const res = await CategoryService.getParentTree(
        token,
        dispatch,
        category
      );

      if (value === null) setSelectedCategoryTree([...res.data.data, category]);

      return res.data.data;
    } catch (e) {}

    return null;
  };

  useEffect(() => {
    if (categories.length === 0) getCategories();
  }, []);

  useEffect(() => {
    setDropdownMatrix([categories]);
  }, [categories]);

  useEffect(() => {
    if (preSelected) {
      fetchCategoryTree(preSelected);
    } else if (noFilter && !preSelected) {
      setValue(null);
      setCategoyInput((prev) => ({ ...prev, 0: "No Filter" }));
    }
  }, [preSelected]);

  useEffect(() => {
    if (value === null || categories.length === 0) return;

    if (value === "") {
      setCategoyInput({});
      setDropdownMatrix([categories]);
    } else {
      fetchCategoryTree(value).then((data) => {
        if (data && !userInteraction.current) {
          setUpCategoryIfPrefilledExists(
            [...data, value],
            setDropdownMatrix,
            (category) => {},
            setCategoyInput,
            categories
          );
        }
      });
    }
  }, [value, categories.length]);

  useEffect(() => {
    if (categories.length > 0 && selectedCategoryTree.length > 0) {
      setUpCategoryIfPrefilledExists(
        selectedCategoryTree,
        setDropdownMatrix,
        (category) => setValue(category),
        setCategoyInput,
        categories,
        noFilter
      );
    } else setDropdownMatrix([categories]);
  }, [selectedCategoryTree]);

  const reset = () => {
    setCategoyInput({});
    setValue(null);
    setDropdownMatrix([categories]);
  };

  const handleChangeDropdownMatrix = (matrix) => {
    userInteraction.current = true;
    setDropdownMatrix(matrix);
  };

  useEffect(() => {
    return () => {
      userInteraction.current = false;
    };
  }, []);

  return {
    dropdownMatrix,
    categoryInput,
    setCategoyInput,
    setDropdownMatrix: handleChangeDropdownMatrix,
    reset,
    userInteraction,
    getCategories,
  };
};
